import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';

import { modalClose } from '@app/store/modal/actions';
import { getActiveModalCount } from '@app/store/modal/selectors';

const propTypes = {
  modalCount: PropTypes.number,
  onClose: PropTypes.func,
};

const defaultProps = {
  modalCount: 0,
  onClose() {},
};

export class PageExitPreventionModalComponent extends Component {
  constructor(props) {
    super(props);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleCloseModalCurrentAndOpener = this.handleCloseModalCurrentAndOpener.bind(this);
  }

  handleCancel() {
    const { onClose } = this.props;
    onClose();
  }

  /**
   * 이 메소드는 모달에서 편집 중 닫기 버튼을 눌렀을 때 편집중인 내용이 사라질 수 있다는
   *   경고 모달(ROUTE_PAGE_EXIT_PREVENTION_MODAL)이 열리고,
   * 확인을 누르면 현재 모달과 오픈한 모달을 같이 닫아주는 역할을 합니다.
   *
   * 현재 모달이 아닌 페이지에서는 브라우저의 confirm창으로 확인메세지를 보여주고 있어서
   * "이 메소드를 실행한 Opener는 Modal일 것이다"라는 가정으로 작성했습니다.
   */
  handleCloseModalCurrentAndOpener() {
    const { modalCount, onClose } = this.props;
    // 현재 모달(ROUTE_PAGE_EXIT_PREVENTION_MODAL) 닫기
    onClose();

    /**
     * 현재 모달(ROUTE_PAGE_EXIT_PREVENTION_MODAL)을 열었을 때 모달이 2개 이상이라면
     * 모달에서 열었을 것이라고 판단하여 모달을 한번 더 닫는다.
     */
    if (modalCount > 1) {
      onClose();
    }
  }

  render() {
    return (
      <div className="Container Container--max-xxs">
        <div className="Card Card--pop align-center box-6x">
          <h4 className="space-2x">
            <strong>설정 안내</strong>
          </h4>
          <p className="space-4x">
            이 창을 닫으면 방금 변경한 정보가
            <br />
            저장되지 않습니다.
          </p>
          <button
            className="Btn Btn--bold-mobile"
            name="cancel"
            type="button"
            onClick={this.handleCancel}
          >
            취소
          </button>
          <button
            className="Btn Btn--primary Btn--bold-mobile"
            name="close"
            type="button"
            onClick={this.handleCloseModalCurrentAndOpener}
          >
            확인
          </button>
        </div>
      </div>
    );
  }
}

PageExitPreventionModalComponent.propTypes = propTypes;
PageExitPreventionModalComponent.defaultProps = defaultProps;

const mapStateToProps = (state) => ({
  modalCount: getActiveModalCount(state),
});

const mapDispatchToProps = {
  onClose: modalClose,
};

export default connect(mapStateToProps, mapDispatchToProps)(PageExitPreventionModalComponent);
